"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDataCorrectionOptionApi = exports.ScheduleDataCorrectionOptionApiFactory = exports.ScheduleDataCorrectionOptionApiFp = exports.ScheduleDataCorrectionOptionApiAxiosParamCreator = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("../base");
/**
 * ScheduleDataCorrectionOptionApi - axios parameter creator
 * @export
 */
exports.ScheduleDataCorrectionOptionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editIdScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ScheduleDataCorrectionOption/Intraday";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication bearer required
                    // http bearer authentication required
                    if (configuration && configuration.accessToken) {
                        accessToken = typeof configuration.accessToken === 'function'
                            ? configuration.accessToken()
                            : configuration.accessToken;
                        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof scheduleMetadataCalculatorFilterDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(scheduleMetadataCalculatorFilterDto !== undefined ? scheduleMetadataCalculatorFilterDto : {}) : (scheduleMetadataCalculatorFilterDto || "");
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ScheduleDataCorrectionOption/DayAhead";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication bearer required
                    // http bearer authentication required
                    if (configuration && configuration.accessToken) {
                        accessToken = typeof configuration.accessToken === 'function'
                            ? configuration.accessToken()
                            : configuration.accessToken;
                        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof scheduleMetadataCalculatorFilterDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(scheduleMetadataCalculatorFilterDto !== undefined ? scheduleMetadataCalculatorFilterDto : {}) : (scheduleMetadataCalculatorFilterDto || "");
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleDataCorrectionOption: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ScheduleDataCorrectionOption";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication bearer required
                    // http bearer authentication required
                    if (configuration && configuration.accessToken) {
                        accessToken = typeof configuration.accessToken === 'function'
                            ? configuration.accessToken()
                            : configuration.accessToken;
                        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                    }
                    localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ScheduleDataCorrectionOptionApi - functional programming interface
 * @export
 */
exports.ScheduleDataCorrectionOptionApiFp = function (configuration) {
    return {
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editIdScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ScheduleDataCorrectionOptionApiAxiosParamCreator(configuration).editIdScheduleDataCorrectionOption(scheduleMetadataCalculatorFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ScheduleDataCorrectionOptionApiAxiosParamCreator(configuration).editScheduleDataCorrectionOption(scheduleMetadataCalculatorFilterDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleDataCorrectionOption: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ScheduleDataCorrectionOptionApiAxiosParamCreator(configuration).getScheduleDataCorrectionOption(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ScheduleDataCorrectionOptionApi - factory interface
 * @export
 */
exports.ScheduleDataCorrectionOptionApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editIdScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            return exports.ScheduleDataCorrectionOptionApiFp(configuration).editIdScheduleDataCorrectionOption(scheduleMetadataCalculatorFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<ScheduleMetadataCalculatorFilterDto>} [scheduleMetadataCalculatorFilterDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduleDataCorrectionOption: function (scheduleMetadataCalculatorFilterDto, options) {
            return exports.ScheduleDataCorrectionOptionApiFp(configuration).editScheduleDataCorrectionOption(scheduleMetadataCalculatorFilterDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleDataCorrectionOption: function (options) {
            return exports.ScheduleDataCorrectionOptionApiFp(configuration).getScheduleDataCorrectionOption(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ScheduleDataCorrectionOptionApi - object-oriented interface
 * @export
 * @class ScheduleDataCorrectionOptionApi
 * @extends {BaseAPI}
 */
var ScheduleDataCorrectionOptionApi = /** @class */ (function (_super) {
    __extends(ScheduleDataCorrectionOptionApi, _super);
    function ScheduleDataCorrectionOptionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ScheduleDataCorrectionOptionApiEditIdScheduleDataCorrectionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleDataCorrectionOptionApi
     */
    ScheduleDataCorrectionOptionApi.prototype.editIdScheduleDataCorrectionOption = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return exports.ScheduleDataCorrectionOptionApiFp(this.configuration).editIdScheduleDataCorrectionOption(requestParameters.scheduleMetadataCalculatorFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ScheduleDataCorrectionOptionApiEditScheduleDataCorrectionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleDataCorrectionOptionApi
     */
    ScheduleDataCorrectionOptionApi.prototype.editScheduleDataCorrectionOption = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return exports.ScheduleDataCorrectionOptionApiFp(this.configuration).editScheduleDataCorrectionOption(requestParameters.scheduleMetadataCalculatorFilterDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleDataCorrectionOptionApi
     */
    ScheduleDataCorrectionOptionApi.prototype.getScheduleDataCorrectionOption = function (options) {
        var _this = this;
        return exports.ScheduleDataCorrectionOptionApiFp(this.configuration).getScheduleDataCorrectionOption(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScheduleDataCorrectionOptionApi;
}(base_1.BaseAPI));
exports.ScheduleDataCorrectionOptionApi = ScheduleDataCorrectionOptionApi;
